import {Fragment, useRef, useState} from 'react';
import Button from "../UI/Button";
import React from "react";
import Modal from "../UI/Modal";
import {createLevel, getLevel, updateLevel} from "../../api/levelApiClient";
import ListEdit from "../UI/ListEdit";
import ModalForm from "../UI/ModalForm";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import Box from "../UI/Box";
import {useLevels} from "../../hooks/useLevels";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

const LevelList = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [level, setLevel] = useState(null);
    const [submitCount, setSubmitCount] = useState(0);
    const nameRef = useRef(null);
    const orderRef = useRef(null);
    const {levels, pagination} = useLevels(page, pageSize, submitCount);
    const navigate = useNavigate();

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const handleEditIconClick = (levelId) => {
        setIsUpdate(true);
        const level = getLevel(levelId);

        level
            .then(
                (data) => {
                    setLevel(data)
                    setShowModal(true)
                }
            )
            .catch(
                (error) => console.log(error)
            );
    }

    const handleShowIconClick = (levelId) => {
        navigate('/levels/' + levelId + '/requirements');
    }

    const handleCreateButtonClick = () => {
        setIsUpdate(false);
        setShowModal(true)
    }

    const handleCreateSubmit = (event) => {
        event.preventDefault();
        const name = nameRef.current.value;
        const order = orderRef.current.value;

        createLevel(name, order)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handleEditSubmit = (event) => {
        event.preventDefault();
        const name = nameRef.current.value;
        const order = orderRef.current.value;

        updateLevel(level.levelId, name, order)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const listHeaders = [
        'Id',
        'Name',
        'Order',
        'Actions'
    ];

    const columns = {
        functionParams : ['levelId'],
        dataKeys       : [
            'levelId',
            'name',
            'order'
        ],
    }

    return <Fragment>
        <Box>
            <Button title='Create level' handleClick={handleCreateButtonClick}/>
            <ListEdit
                headers={listHeaders}
                items={levels}
                columns={columns}
                pagination={pagination}
                handleEditIconClick={handleEditIconClick}
                handleShowIconClick={handleShowIconClick}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
            />
        </Box>
        {showModal && (
            <Modal>
                <form onSubmit={isUpdate ? handleEditSubmit : handleCreateSubmit}>
                    <ModalForm
                        title={isUpdate ? 'Update level' : 'Create level'}
                        saveButtonTitle={isUpdate ? 'Update' : 'Create'}
                        handleCancelButtonClick={() => setShowModal(false)}
                    >
                        <ModalFormInputRow title='Name'>
                            <input
                                ref={nameRef}
                                type="text"
                                id="name"
                                name="name"
                                defaultValue={isUpdate ? level.name : null}
                                placeholder="Enter name"
                                className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline"
                            />
                        </ModalFormInputRow>
                        <ModalFormInputRow title='Order'>
                            <input
                                ref={orderRef}
                                type="text"
                                id="order"
                                name="order"
                                defaultValue={isUpdate ? level.order : 1}
                                placeholder="Enter order"
                                className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline"
                            />
                        </ModalFormInputRow>
                    </ModalForm>
                </form>
            </Modal>
        )}
    </Fragment>;
}

export default LevelList;